module.exports = __webpack_public_path__ + "img/criminal_case_part_3_splash.a1eeb500.jpg";